import { useCreateAptStore } from "@elixir/stores";
import { BasicDoctorInfo } from "@elixir/types";
import React, { useMemo } from "react";
import { NewAptSelectDoctorUi } from "ui";
import useQueueStore from "../../../../stores/queue-store";
import { useMyAccessProfileV2 } from "../../../../apis/tryst/get-my-access-profile";
import SearchDoctorDropdown from "./search-doctor";
import useGetQueueConfig from "../../../../apis/tryst/get-queue-config";

const NewAptSelectDoctor = () => {
  const { data: queueConfigData, isLoading } = useGetQueueConfig();

  const dropdownSelectedClinic = useCreateAptStore(
    (state) => state.selectedClinic
  );
  const clinicId = useQueueStore((state) => state.clinicId);
  const clearSelectedSlot = useQueueStore((state) => state.clearSelectedSlot);

  const { data: myAccessProfile } = useMyAccessProfileV2({ clinicId: dropdownSelectedClinic });

  const docOptions = useMemo(() => {
    const doctorList = [...(myAccessProfile?.doctors || [])];
    return doctorList;
  }, [
    clinicId,
    myAccessProfile?.clinics,
    myAccessProfile?.doctors,
  ]);

  const dropdownSelectedDoctor = useCreateAptStore(
    (state) => state.selectedDoctor
  );

  const selectedDoctor = useQueueStore((state) => state.selectedDoctor);

  const setDropdownSelectedDoctor = useCreateAptStore(
    (state) => state.setSelectedDoctor
  );

  React.useEffect(() => {
    const shouldSetDefaultDoctor = !dropdownSelectedClinic || (
      dropdownSelectedClinic && 
      !myAccessProfile?.allDocs
        .find((doc) => doc.oid === dropdownSelectedDoctor?.oid)
        ?.clinics.includes(dropdownSelectedClinic)
    );

    if (shouldSetDefaultDoctor) {
      setDropdownSelectedDoctor(myAccessProfile?.doctors?.[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myAccessProfile?.doctors]);


  React.useEffect(() => {
    if (dropdownSelectedDoctor?.oid === selectedDoctor?.oid) {
      return;
    } else if (dropdownSelectedClinic) {
      const doc = myAccessProfile?.allDocs.find((doc) => doc.oid === selectedDoctor?.oid)
      
      if (doc?.clinics.includes(dropdownSelectedClinic)) {
          setDropdownSelectedDoctor({
            oid: doc.oid,
            name: doc.name,
            username: doc.username,
            pic: doc.pic
          });
        } 
    }
  }, [selectedDoctor])

  const onSelectDoctorClick = (doctor?: BasicDoctorInfo) => {
    clearSelectedSlot();
    setDropdownSelectedDoctor(doctor);
  };

  const [searchTerm, setSearchTerm] = React.useState("");

  if (
    myAccessProfile?.allDocs?.length === 1
  ) {
    return null;
  }

  return (
    <NewAptSelectDoctorUi
      selectedDoctor={dropdownSelectedDoctor}
      onClear={() => {
        onSelectDoctorClick(undefined);
      }}
      fieldTitle={"Doctor"}
      fieldPlaceholder={"Select Doctor"}
      onSearchTermChange={setSearchTerm}
      suggestionsUi={
        <SearchDoctorDropdown
          doctorsData={docOptions}
          searchQuery={searchTerm}
          onSelectDoctor={onSelectDoctorClick}
        />
      }
      searchTerm={searchTerm}
    />
  );
};

export default NewAptSelectDoctor;
